<template>
    <div class="row justify-content-center">
        <div class="login-wrap">
            <template v-if="invalid">
                <div class="row mt-4">
                    <div class="col-md-12">
                        <div class="error-message alert alert-danger">{{ invalid }}</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <form @submit.prevent="reset_password">
                    <input type="hidden" v-model="reseter.counter">
                    <div class="row">
                        <div class="col-md-12">
                            <template v-if="!isSuccess">
                                <p class="mb-1">
                                    <b>Security Update:</b> 
                                    We are requiring all our customers to reset their password.
                                    Please click the button below and we will send a password reset link to your email ({{ user.email }}).
                                </p>
                                <br>
                                <center>
                                    <button class="btn" type="button" :disabled="isSubmitting" @click="submit">
                                        <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                        <template v-else>Send Password Reset Link</template>
                                    </button>
                                    <a @click="skip_reset" href="#skip" :disabled="isSkipping" v-if="user.can_skip && user.can_skip > 0">
                                        <span v-if="isSkipping">Skipping...</span>
                                        <span v-else>Skip ({{ user.can_skip }})</span>
                                    </a>
                                </center>
                            </template>
                            <template v-else>
                                <p class="mb-0">
                                    A password reset link was sent to <b>{{ email }}</b>. 
                                    If you didn't receive any email 
                                    <template v-if="isSubmitting"><b><span class="fa fa-spinner fa-pulse"></span></b></template>
                                    <template v-else>
                                        <a href="javascript:void(0);" @click="submit"><b>Click Here</b></a>
                                    </template>
                                    to try again.
                                </p>
                            </template>
                        </div>
                    </div>
                </form>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: false,
            isSkipping: false,
            isSubmitting: false,
            invalid: false,
            password_reset_status: false,
            mandatory_reset_date: false,
            isSuccess: false,
            errors: [],
            security_questions: [],
            user: {},
            reseter : { counter : 1 },
            model: {
                username: '',
                token: '',
                password: '',
                password_confirmation: '',
                security_question: '',
                security_answer: '',
                field_account_id: '',
                field_account_username: '',
                field_account_email: ''
            },
            password_validation: {
                char_length: false,
                lowercase: false,
                uppercase: false,
                digit: false,
                special_char: false
            }
        }
    },
    mounted() {
        var user = localStorage.getItem('user');
        this.user = JSON.parse(user);
        this.model.username = this.$route.params.username
        this.model.token = this.$route.params.token
        this.get_security_questions()
        this.check_reset()
        // this.check_reset_password_token()
        // this.reset_password_user()
    },
    methods: {
        reset_password_user() {
            this.$http.post('/api/reset_password_user', { username: this.model.username })
                .then((res) => {
                    if(res.data.security_question) {
                        this.model.security_question = res.data.security_question
                    }
                    this.model.security_answer = res.data.security_answer
                    this.model.field_account_id = res.data.field_account.id
                    this.model.field_account_username = res.data.field_account.username
                    this.model.field_account_email = res.data.field_account.email
                    this.user = res.data.user
                })
        },
        check_reset() {
            this.$http.get('/api/user-check/check_reset', this.model)
                .then((res) => {
                    this.user.can_skip = res.data.can_skip
                    console.log('skip',this.user.can_skip);
                    this.sub_reset();
                })
        },
        check_user() {
            let user = localStorage.getItem('user')
            if(user) {
                user = JSON.parse(user)
                this.model.id = user.id
                this.model.username = user.username
                this.password_reset_status = user.password_reset_status
                this.mandatory_reset_date = user.mandatory_reset_date
                this.user = user
            }
        },
        submit() {
            this.isSubmitting = true
            this.check_user()

            this.$http.post('/api/reset_password_token', this.model)
                .then((res) => {
                    this.isSubmitting = false
                    this.isSuccess = true
                    this.email = res.data.data.email
                })
                .catch(() => {
                    this.isSubmitting = false
                })
        },
        check_reset_password_token() {
            this.$http.post('/api/check_reset_password_token', this.model)
                .then(() => {
                    this.invalid = false
                })
                .catch((error) => {
                    this.invalid = error.response.data.message
                })
        },
        get_security_questions() {
            this.$http.get('/api/security_questions')
                .then(response => {
                    this.security_questions = response.data.data
                })
        },
        skip_reset() {
            this.$http.post('/api/user/skip_reset', this.model)
                .then((res) => {
                    this.user.can_skip = res.data.can_skip
                    this.user.need_reset = 0;
                    localStorage.setItem('user', JSON.stringify(this.user));
                    localStorage.removeItem('need_reset');
                    if (this.user.role === 'project-manager' || this.user.role === 'super_admin' || this.user.role === 'administrator') {
                      location.href = '/project/projects';
                    } else {
                      location.href = '/project/dashboard';
                    }
                })
        },
        reset_password() {
            this.isSubmitting = true
            this.errors = []

            this.$http.post('/api/reset_password', this.model)
                .then(() => {
                    localStorage.setItem('user', '')
                    localStorage.removeItem('need_reset');
                    window.location.href = '/project/login'
                })
                .catch((error) => {
                    this.isSubmitting = false
                    if(error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                })
        },
        sub_reset(){
            var ctr = this.reseter.counter;
            this.$set(this.reseter,'counter',ctr+2);
            this.$set(this.reseter,'counter',ctr+1);
        },
        validate_password() {
            if(this.model.password.length >= 8) {
                this.password_validation.char_length = true
            } else {
                this.password_validation.char_length = false
            }

            if((/[a-z]/.test(this.model.password))) {
                this.password_validation.lowercase = true
            } else {
                this.password_validation.lowercase = false
            }

            if((/[A-Z]/.test(this.model.password))) {
                this.password_validation.uppercase = true
            } else {
                this.password_validation.uppercase = false
            }

            if((/[0-9]/.test(this.model.password))) {
                this.password_validation.digit = true
            } else {
                this.password_validation.digit = false
            }

            if((/[~`!@#$%^&*()\-_+={}[\]|\\:;"'<>,.?/]/.test(this.model.password))) {
                this.password_validation.special_char = true
            } else {
                this.password_validation.special_char = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.form-control {
    border: 1px solid #102e6c;
    border-radius: 4px;
    font-size: 13px;
    height: 47px;
    padding: 5px 10px;
    margin-bottom: 0.5em;
}
.btn-primary {
    padding: 12px 30px;
    width: 100%;
}
.error-message{
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    padding: 10px 15px;
    margin-bottom: 8px;
    border: 1px solid transparent;
    border-radius: 4px;
}
.validation {
    color: #404040;
    .fa-check-circle {
        color: #459e45;
    }
    .fa-circle {
        color: #e6e6e6;
    }
}
</style>
